import { createContext } from 'react'
import type { AuthTokens, Customer, LineProfile } from '@/types'

export interface AuthContextType {
  isAuthenticated: boolean
  isLoading: boolean
  customer: Customer | null
  lineProfile: LineProfile | null
  login: (tokens: AuthTokens) => Promise<void>
  logout: () => Promise<void>
}

export const AuthCtx = createContext<AuthContextType | undefined>(undefined)
